import { Box, Divider, Typography } from "@mui/material";
import React, { useMemo } from "react";
import { PageWrapper } from "../../../app/container/PageWrapper";
import { Section } from "../../../common/components";
import { useJobRequests } from "../../../common/hooks/job-requests/useJobRequests";
import DraftJobRequestItem from "./DraftJobRequestItem";
import { DraftsJobRequestSkeleton } from "./DraftsJobRequestSkeleton";

export const DraftJobRequests: React.FC = () => {
  const { data: jobRequests, isFetching: isLoadingJobRequests } =
    useJobRequests(true);

  const errorMessage = useMemo(() => {
    return !jobRequests?.length && !isLoadingJobRequests
      ? "Saved job request drafts will be shown here."
      : "";
  }, [isLoadingJobRequests, jobRequests?.length]);

  return (
    <PageWrapper>
      <Box height="100%" py={10}>
        <Section
          errorMessage={errorMessage}
          isLoading={isLoadingJobRequests}
          loadingSkeleton={<DraftsJobRequestSkeleton />}
        >
          <Typography
            variant="h1"
            sx={{
              fontWeight: "bold",
            }}
          >
            Drafts for Job Requests
          </Typography>
          <Box display="flex" flexDirection="column">
            {jobRequests?.map((jobRequest) => (
              <Box key={jobRequest._id} py={10}>
                <DraftJobRequestItem
                  jobRequest={jobRequest}
                  isLoading={isLoadingJobRequests}
                />
                <Box py={2.5}>
                  <Divider />
                </Box>
              </Box>
            ))}
          </Box>
        </Section>
      </Box>
    </PageWrapper>
  );
};
